import React, { useState, useEffect, useRef } from "react";

// Model Layout Component - CareEconomy
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const careLayers = [
  {
    id: "cem1",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem1.svg",
    alt: "care economy",
    style: { left: "76.8%", top: "56.5%" },
  },
  {
    id: "cem2",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem2.svg",
    alt: "care economy",
    style: { right: "-4%", bottom: "-11%" },
  },
  {
    id: "cem3",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem3.svg",
    alt: "care economy",
    style: { left: "27.2%", top: "53.5%", zIndex: 50 },
  },
  {
    id: "cem4",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem4.svg",
    alt: "care economy",
    style: { left: "51%", top: "19%", zIndex: 40 },
  },
  {
    id: "cem5",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem5.svg",
    alt: "care economy",
    style: { left: "45%", bottom: "10%", zIndex: 50 },
  },
  {
    id: "cem6",
    src: "/assets/svgs/care-economy-svgs/mobile-svgs/cem6.svg",
    alt: "care economy",
    style: { left: "37.6%", bottom: "-10%", zIndex: 40 },
  },
];

const CareEconomyMobileModel = ({
  className = "",
  showTooltips = true,
  isParentLoading = false,
  isPopUpOpen = false,
}) => {
  const [shouldJiggle, setShouldJiggle] = useState(false);
  const jiggleTriggeredRef = useRef(false);

  useEffect(() => {
    if (!isParentLoading && !isPopUpOpen && !jiggleTriggeredRef.current) {
      jiggleTriggeredRef.current = true;
      const timer = setTimeout(() => {
        setShouldJiggle(true);
        const stopTimer = setTimeout(() => {
          setShouldJiggle(false);
        }, 1500);
        return () => clearTimeout(stopTimer);
      }, 600); // Starts slightly after loader/popup clears
      return () => clearTimeout(timer);
    }
  }, [isParentLoading, isPopUpOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      cem4: "what-is-care-economy",
      cem3: "care-economy-india",
      cem6: "care-economy-indonesia",
      cem2: "care-economy-nepal",
      cem5: "care-economy-bangladesh",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[4/7] max-w-[500px] ${className}`}
        >
          {careLayers.map((layer) => {
            const interactive = layer.id !== "cem1";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 left-[70%] mb-5";
                case "bottom":
                  return "top-full left-[57%] -translate-x-1/2 mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${
                  interactive ? "group" : ""
                }`}
                style={layer.style}
              >
                <div className="relative">
                  <div className={interactive && shouldJiggle ? "animate-jiggle" : ""}>
                    <img
                      src={layer.src}
                      alt={layer.alt}
                      loading="lazy"
                      className={`select-none max-w-max object-contain ${
                        interactive
                          ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                          : "pointer-events-none"
                      }`}
                      style={interactive ? { ...hoverTiming } : undefined}
                      {...(interactive ? bounceHandlers : {})}
                      {...(handleClick ? { onClick: handleClick } : {})}
                    />
                  </div>
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default CareEconomyMobileModel;
